<template>
  <LoaderWrapper ref="loader" class="h-100">
    <div class="p-3 row pt-0">
      <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
        <div class="col p-0">
          <div class="">
            <DatePicker v-model="filters.fromDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
              <template v-slot="{ inputValue, togglePopover, inputEvents }">
                <input
                  class="form-control form-control-sm"
                  :placeholder="helper.trans('labels.from_date')"
                  :value="inputValue"
                  @focus="togglePopover"
                  @change="inputEvents.change"
                />
              </template>
            </DatePicker>
          </div>
        </div>
      </div>

      <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
        <div class="col p-0">
          <div class="">
            <DatePicker v-model="filters.toDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
              <template v-slot="{ inputValue, togglePopover, inputEvents }">
                <input
                  class="form-control form-control-sm"
                  :placeholder="helper.trans('labels.to_date')"
                  :value="inputValue"
                  @focus="togglePopover"
                  @change="inputEvents.change"
                />
              </template>
            </DatePicker>
          </div>
        </div>
      </div>

      <div class="form-group mb-2 col">
        <div class="col-auto p-0 text-end">
          <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">
            {{ helper.trans('button.apply') }}
          </button>
        </div>
      </div>

    </div>


    <div class="p-3 pt-0" v-if="device">
      <div class="">
        <table class="table table-striped border-light align-middle text-left">
          <thead>
          <tr>
            <th class="text-capitalize-first">{{ helper.trans('labels.id_date') }}</th>
            <th class="text-capitalize-first">{{ helper.trans('labels.status') }}</th>
            <th class="text-capitalize-first">{{ helper.trans('labels.type') }}</th>
            <th class="text-capitalize-first">
              {{ helper.trans('labels.message') }}
              <span v-if="isAdmin || isOperator">
                <i @click.prevent="helper.hideSensitiveData()"  v-if="helper.isSensitiveDataVisible()" class="fa fa-eye"></i>
                <i @click.prevent="helper.showSensitiveData()" v-else class="fa fa-eye-slash"></i>
              </span>

            </th>
            <th class="text-capitalize-first">{{ helper.trans('labels.trade_deal') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in paginatedResponse.items" :key="index" class="">
            <td>
              <div class="d-flex flex-column mt-1 mb-1">
                <span>
                  <span v-b-tooltip.hover :title="item.log.message.id">{{ item.log.message.id.substring(0, 8) }}...</span> <copy-button :value="item.log.message.id"></copy-button>
                </span>
                <small class="text-secondary">{{ dateHelper.format(item.log.message.created_at) }}</small>
              </div>
            </td>
            <td>
              {{ item.log.message.status }}
            </td>
            <td>
              <div class="d-flex flex-column">
                <span>{{ helper.trans(`message_log.type.${item.log.message.message_source.trigger}`) }} - {{ item.log.bank?.name }}</span>
                <small v-if="item.log.message.user_agent" class="text-secondary">{{ parseUserAgent(item.log.message.user_agent) }}</small>
              </div>
            </td>
            <td>
              <div v-if="item.log.message.message_source.trigger === 'app_push_notification'">
                <strong>
                  {{ item.log.message.message_source.app_push_notification.title}}
                </strong>
                <br>
                {{ item.log.message.message_source.app_push_notification.notification}}
              </div>
              <div v-else-if="item.log.message.message_source.trigger === 'sms'">
                <strong>
                  {{ item.log.message.message_source.sms.number}}
                </strong>
                <br>
                {{ item.log.message.message_source.sms.message}}
              </div>
              <div v-else>
                {{ JSON.stringify(item.log.message.message_source)}}
              </div>
              <div v-if="isAdmin || isOperator" class="sensitive-data" style="word-break: break-all">
                <small class="text-secondary">
                  {{ item.log.message.message_parser_name }} {{ item.log.message.message_parser_version }} <br>
                  {{ JSON.stringify(item.log.message.message_parsing)}}
                </small>
              </div>
            </td>
            <td class="text-nowrap">
              <div v-if="!item.notification">
                n/a
              </div>
              <div v-else>
                <div v-for="error in item.notification.errors" :key="error">
                  <span class="text-danger">{{ helper.trans(`message_log.error.${error}`)}}</span>
                </div>

                <div v-if="item.notification.dealId">

                  <span>
                    <span v-b-tooltip.hover :title="item.notification.dealPublicId">{{ item.notification.dealPublicId }}</span> <copy-button :value="item.notification.dealPublicId"></copy-button>
                  </span>

                  <button type="button" @click="showDealDetails(item.notification.dealId)" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize ms-2"><i class="fa fa-list"></i>
                    {{ helper.trans('button.details') }}</button>
                </div>
              </div>

            </td>
          </tr>
          </tbody>
        </table>
        <b-pagination
          v-if="paginatedResponse.totalCount > paginatedResponse.items.length"
          v-model="page"
          :total-rows="paginatedResponse.totalCount"
          :per-page="paginatedResponse.limit"
          :limit="20"
          @update:modelValue="load()"
          :prev-text="helper.trans('button.back')"
          :next-text="helper.trans('button.next')"
          align="start"
          first-number
          hide-goto-end-buttons
          hide-ellipsis
        ></b-pagination>
      </div>
    </div>

    <b-modal title=""
             dialog-class="modal-lg"
             :modelValue="dealDetailsModal"
             footer-class="d-flex justify-content-end"
             @update:modelValue="dealDetailsModal = $event">
      <template #default>
        <LoaderWrapper ref="loaderDealDetailsModal" class="h-100">
          <TradeDealDetailsTable v-if="detailsDeal" :deal="detailsDeal"/>
        </LoaderWrapper>
      </template>
      <template #footer>
        <button type="button" @click.prevent="dealDetailsModal = false" class="btn btn-outline-dark btn-sm text-capitalize-first">
          {{ helper.trans('button.ok')  }}
        </button>
      </template>
    </b-modal>

  </LoaderWrapper>
</template>

<script lang="ts">

import {defineComponent, PropType, Prop, watch, ref, computed} from 'vue'
import {helper} from "@/service/CommonHelper";
import {reactive, toRefs} from "@vue/reactivity";
import APIClient from "@/service/APIClient";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import CopyButton from "@/components/CopyButton.vue";
import {useStore} from "vuex";
import TraderDeviceDTO from "@/models/TraderDeviceDTO";
import TraderDealDTO from "@/models/TraderDealDTO";
import TradeDealDetailsTable from "@/components/TradeDealDetailsTable.vue";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import {DatePicker} from "v-calendar";

const api = new APIClient();

export default defineComponent({
  components: {
    DatePicker,
    TradeDealDetailsTable,
    LoaderWrapper,
    CopyButton,
  },
  props: {
    fromDate: {
      type: String as PropType<String>,
      default: null
    } as Prop<String>,
    toDate: {
      type: String as PropType<String>,
      default: null
    } as Prop<String>,
    device: {
      type: Object as PropType<TraderDeviceDTO>,
      default: null
    } as Prop<TraderDeviceDTO>
  },
  setup(props) {
    const store = useStore()

    helper.initCopyHints();

    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const loaderDealDetailsModal = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({

      filters: {fromDate: null, toDate:null} as any,
      dealDetailsModal: false,
      detailsDeal: null as TraderDealDTO|null,
      page: 1,
      limit: 20,
      paginatedResponse: {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<any>
    });

    watch(() => props.toDate, async () => {
      state.filters.toDate = props.toDate
    })

    watch(() => props.fromDate, async () => {
      state.filters.fromDate = props.fromDate
    })

    watch(() => props.device, async () => {
      state.filters =  {fromDate: props.fromDate, toDate: props.toDate}
      state.paginatedResponse = {
        limit: 20,
        offset: 0,
        totalCount: 0,
        items: []
      } as PaginatedResponseDTO<any>
      state.page = 1;

      if (!props.device) {
        return;
      }

      await load();
    })

    const applyFilters = async () => {
      state.page = 1;
      load()
    }

    const load = async () => {
      if (!props.device) {
        return;
      }

      loader.value?.show()
      try {
        const offset = state.limit * (state.page - 1)
        state.paginatedResponse = await api.devicesMessageLogs(props.device.id, {
          limit: state.limit,
          offset: offset,
          fromDate: dateHelper.toUTC(state.filters.fromDate),
          toDate: dateHelper.toUTC(state.filters.toDate),
        });
      } finally {
        loader.value?.hide()
      }
    }

    const showDealDetails = async (dealId: string) => {
      state.dealDetailsModal = true;
      loaderDealDetailsModal.value?.show();
      try {
        state.detailsDeal = await api.deal(dealId)
      } finally {
        loaderDealDetailsModal.value?.hide();
      }
    }

    const parseUserAgent = (ua: string) => {
      if (!ua) {
        return ua;
      }

      return ua.replace(/(^.)(.+)(\/.*)/, '$1$3');
    }


    return {
      ...toRefs(state),
      isAdmin: computed(() => store.getters.isAdmin),
      isOperator: computed(() => store.getters.isOperator),
      loader,
      loaderDealDetailsModal,
      dateHelper,
      numberFormatter,
      showDealDetails,
      helper,
      applyFilters,
      load,
      parseUserAgent
    }
  }
})
</script>
